import styles from "./PageNotFound.module.css";

export default function PageNotFound() {
  return (
    <main className={styles.page_not_found}>
      <h1><span className={styles.status_code}>404</span> Page not found</h1>
      <h2>...How did you get here?</h2>
    </main>
  )
}